import { Reveal } from "@/components/motion";

const COLS = [
  { title: "STRATEGIC", body: "Connect sustainability with business strategy." },
  { title: "EVIDENCE-BASED", body: "Build decisions around credible data and recognised frameworks." },
  { title: "INTEGRATED", body: "Environment. Social. Governance. Climate. Capital." },
  { title: "ACTION-ORIENTED", body: "Turn assessments into clear priorities and implementation roadmaps." },
];

export default function WhyUs() {
  return (
    <section className="bg-white text-ink sec" data-testid="why-us">
      <div className="wrap">
        <Reveal>
          <h2 className="h-display font-bold text-[32px] sm:text-5xl lg:text-[56px] leading-[1.06] mb-16">
            We make ESG and sustainability practical.
          </h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-testid="why-us-columns">
          {COLS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div className="border-t-2 border-gold pt-6">
                <p className="eyebrow text-ink font-bold mb-4">{c.title}</p>
                <p className="text-ink/70 text-[14.5px] leading-relaxed">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
